<template>
    <div class="nav__contain animate__animated animate__fadeIn">
        <div class="banner"><img :src="banner"></div>
        <div class="main-nav-wrapper" v-if="!noNeedCate">
            <div class="shop-btn">{{senObject.name}}</div>
            <div class="main-nav" v-if="senObject.child" >
                <ul class="main-nav-list">
                    <router-link tag="li" active-class="active" v-for="(item, index) in senObject.child" :key="index" :to="item.path" >{{item.name}}</router-link>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    import {cateList} from '@/libs/router'
    // icon_stra
    export default {
        name: 'NavSecond',
        props: ['banner', 'noNeedCate'],
        data (){
            return {
                senObject: {
                    name: '',
                    child: [],
                }
            }
        },
        components: {
        },
        computed: {
        },
        mounted() {
            cateList.map((val, key)=>{
                if (this.$route.path.indexOf(val.parentname) != -1 && val.parentname != '/'){
                    console.log(this.$route.path,val.parentname)
                    this.senObject = val
                }
            })
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .nav__contain{
        position: relative;
        z-index: 22;
        .banner{
            width: 100%;
            height: 424px;
            img{
                height: 100%;
                width: 100%;
                display: block;
                object-fit: cover;
            }
        }
        .shop-btn {
            cursor: pointer;
            background: #F1F1F1;
            font-size: 18px;
            font-weight: 300;
            color: #010101;
            writing-mode: vertical-rl;
            /*letter-spacing: 7px;*/
            position: relative;
            height: 200px;
            text-align: center;
            padding: 0 40px;
            top: 0px;
            &::after {
                content: '';
                position: absolute;
                right: -20px;
                top: 50%;
                margin-top: -4px;
                width: 54px;
                height: 1px;
                border-bottom: 1px solid #000;
            }
        }
        .main-nav-wrapper {
            z-index: 222;
            position: absolute;
            left: 0;
            bottom: -200px;
            text-align: left;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-transition: background-color 0.3s linear;
            transition: background-color 0.3s linear;
        }

        .main-nav-wrapper:hover {
            color: #000;
            background-color: #F1F1F1;
        }
        .main-nav-wrapper:hover .main-nav {
            opacity: 1;
            width: 300px;
            padding-left: 30px;
        }
        .main-nav {
            width: 0;
            padding: 0;
            opacity: 0;
            margin: auto 0;
            overflow: hidden;
            /*max-height: -webkit-calc(100vh - 180px);*/
            /*max-height: calc(100vh - 180px);*/
            color: #000;
            -webkit-transition: width .5s, padding .5s, opacity .5s;
            transition: width .5s, padding .5s, opacity .5s;
            background: rgba(241,241,241, 0.6);
        }
        .main-nav-list {
            font-size: 12px;
            width: 254px;
            padding-bottom: 20px;
            /*padding-top: 80px;*/
            /*max-height: -webkit-calc(100vh - 180px);*/
            /*max-height: calc(100vh - 180px);*/
            overflow-y: auto;
            li{
                cursor: pointer;
                font-size: 14px;
                font-weight: 400;
                color: #333;
                margin-top: 20px;
                &:hover{
                    opacity: .5;
                }
            }
            .router-link-exact-active.active{
                opacity: .5;
            }
        }
    }
</style>
